import React from "react";

export default function PhoneFrame({ children, className = "" }) {
  return (
    <div className={`ps-app-shell ps-grain ${className}`} data-testid="app-shell">
      {children}
    </div>
  );
}
